import { intersectRoles } from './../helpers/auth-helpers'
import { InputPotencia } from 'common/types/Potencia'
import { IUser } from 'common/types/User'
import { userModule } from '@/store'

export function criarPotencia(): InputPotencia {
	const usuario = userModule.currentUser
	if (!usuario) throw new Error('Usuário não logado')
	if (usuario.role === 'Visitante') throw new Error('Usuário visitante inesperado')
	return {
		nome: '',
		somar: usuario.somar!._id,
	}
}

export const adminPotenciaGuard = (idPotencia: string | null) =>
	(user: IUser | null) =>
		user &&
		user.role !== 'Visitante' &&
		intersectRoles(user.role, 'admin-potencia') &&
		user.potencia._id === idPotencia

export const storageLogoPotenciaRef = process.env.NODE_ENV === 'production'
	? 'logo-potencias'
	: 'logo-potencias-dev'
